import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, map, debounceTime, interval } from 'rxjs';
import { AgencyRoleType } from '../utilities/enums/agencyrole.enum';
import { HttpService } from '../utilities/services/http.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-connections',
  templateUrl: './connections.component.html',
  styleUrls: ['./connections.component.scss'],
})
export class ConnectionsComponent implements OnInit, AfterViewInit, OnDestroy {
  showLoader: boolean = true;
  @ViewChild('inputSearch', { static: true }) inputSearch!: ElementRef;
  connectionList: any[] = [];

  userEmail;
  searchValue;
  unreadStart = 0;

  @Output() startChat = new EventEmitter();
  @Output() openAddresBook = new EventEmitter();
  @Output() openNewMessage = new EventEmitter();
  @Output() closeUser = new EventEmitter();

  unreadCountList: any[] = [];
  unreadCountSubscription!: any;

  public static self: ConnectionsComponent;

  constructor(
    private router: Router,
    private _snackBar: MatSnackBar,
    private httpService: HttpService,
    public translate: TranslateService,
    public appComponent: AppComponent
  ) {
    ConnectionsComponent.self = this;
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    this.userEmail = localStorage.getItem('userEmail');
  }


  ngOnInit(): void { }
  ngAfterViewInit(): void {
    this.debounce(this.inputSearch.nativeElement, 'keyup').subscribe((val) => {
      if (this.userEmail) {
        this.getConnections(this.userEmail, val);
      }
    });


    if (this.userEmail) {
      this.getConnections(this.userEmail);
    }

    this.unreadCountSubscription = interval(10000).subscribe(() => {
      this.getUnreadCount();
    });
  }

  ngOnDestroy(): void {
    if (this.unreadCountSubscription) {
      this.unreadCountSubscription.unsubscribe();
    }
  }

  showUserName(data: any) {
    // console.log("Connection Data",data)
    const userId = localStorage.getItem('userId');
    const userRole = localStorage.getItem('Role');
    if (userId) {
      if (userRole === "SUPPORT") {
        if (data.fromUserId === userId || data.fromUserId === "SembraCareSuccess") {
          return data.toUserName ? data.toUserName : data.toUserId;
        } else {
          return data.fromUserName ? data.fromUserName : data.toUserId;
        }
      }
      if (userRole === "SEMBRANETADMIN") {
        if (data.fromUserId === userId || data.fromUserId === "SembraNetSupport") {
          return data.toUserName ? data.toUserName : data.toUserId;
        } else {
          return data.fromUserName ? data.fromUserName : data.toUserId;
        }
      }
      if (userRole === "SPECIALTYSUPPORT" || userRole === "ADMIN" || userRole === "SUPPORT") {
        let chatGroups: any = localStorage.getItem("chatGroups")
        if (chatGroups) {
          if (data.fromUserId === userId || chatGroups.indexOf(data.fromUserId) > -1)
            return data.toUserName ? data.toUserName : data.toUserId;
          else
            return data.fromUserName ? data.fromUserName : data.toUserId;
        }
      }
      if (data.fromUserId === userId) {
        return data.toUserName ? data.toUserName : data.toUserId;
      } else {
        return data.fromUserName ? data.fromUserName : data.toUserId;
      }
    }
  }

  getUserEmail(data: any) {
    const userEmail = localStorage.getItem('userEmail');
    let userRole = localStorage.getItem('Role')
    if (userEmail) {
      if (userRole === "SUPPORT") {
        if (data.fromUserId === "SembraCareSuccess" || data.toUserId === "SembraCareSuccess") {
          if (data.fromUserId !== "SembraCareSuccess")
            return data.fromUserId;
          else if (data.toUserId !== "SembraCareSuccess")
            return data.toUserId;
        }
      }
      if (userRole === "SEMBRANETADMIN") {
        if (data.fromUserId === "SembraNetSupport" || data.toUserId === "SembraNetSupport") {
          if (data.fromUserId !== "SembraNetSupport")
            return data.fromUserId;
          else if (data.toUserId !== "SembraNetSupport")
            return data.toUserId;
        }
      }
      if (userRole === "SPECIALTYSUPPORT" || userRole === "ADMIN" || userRole === "SUPPORT") {
        let chatGroups: any = localStorage.getItem("chatGroups");
        if (chatGroups) {
          if (chatGroups.indexOf(data.fromUserId) > -1 || chatGroups.indexOf(data.toUserId) > -1) {
            if (chatGroups.indexOf(data.fromUserId) === -1) {
              return data.fromUserId;
            }
            else if (chatGroups.indexOf(data.toUserId) === -1) {
              return data.toUserId;
            }
          }
        }
      }
      if (data.fromUserId !== userEmail)
        return data.fromUserId;
      else if (data.toUserId !== userEmail)
        return data.toUserId;
    }
  }

  debounce(element: any, event: any, time = 500) {
    const eventObserver = fromEvent(
      this.inputSearch.nativeElement,
      'keyup'
    ).pipe(map((i: any) => i.currentTarget.value));
    return eventObserver.pipe(debounceTime(100));
  }

  getConnections(loginUser: string, search?: string) {
    this.showLoader = true;
    this.httpService.getConnections(loginUser, search).subscribe({
      next: (res: any) => {
        this.showLoader = false;
        this.connectionList = res;
        for (let index = 0; index < this.connectionList.length; index++) {
          const element = this.connectionList[index];
          element['unread'] = 0;
          let connDate = new Date(element.updateTime).setHours(0, 0, 0, 0);
          let todayDate = new Date().setHours(0, 0, 0, 0);
          if (connDate == todayDate)
            element['updateTime'] = new Date(element.updateTime)
              .toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
          else
            element['updateTime'] = new Date(element.updateTime).toLocaleDateString();
        }

        this.getUnreadCount(true);
      },
      error: (error) => {
        if (error.status === 401) {
          this.appComponent.renewToken()
          // localStorage.clear();
          // this.router.navigate(['/login']);
        }
      },
      complete: () => { },
    });
  }

  checkYou(email: string) {
    return localStorage.getItem('userEmail') === email;
  }

  gotoChat(data: any) {
    const dataUser = {
      email: this.getUserEmail(data),
      name: this.showUserName(data),
      connectionId: data._id,
      alertGroup: data.alertGroup
    }

    let groupFound = "";
    let chatGroups: any = localStorage.getItem("chatGroups")
    if (chatGroups) {
      if (chatGroups) {
        let groupList = chatGroups.split(',');
        groupList.map(group => {
          if (group.indexOf(data.toUserId) > -1 || group.indexOf(data.fromUserId) > -1)
            groupFound = group;
        })
      }
    }
    if (groupFound)
      dataUser["group"] = groupFound;

    this.startChat.emit(dataUser);
  }

  gotoAddressbook() {
    this.openAddresBook.emit(true);
  }

  gotoNewMessage() {
    this.openNewMessage.emit(true);
  }

  close() {
    this.closeUser.emit(true);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  checkRole(Role: string) {
    // remove the below line to work code as per role
    const loginUserRole = localStorage.getItem('Role');
    if (
      loginUserRole === AgencyRoleType.ADMIN ||
      loginUserRole === AgencyRoleType.OWNER ||
      loginUserRole === AgencyRoleType.SUPPORT ||
      loginUserRole === AgencyRoleType.SPECIALTYSUPPORT
    ) {
      // as per rule the above roles can chat with everyone
      return true;
    } else if (
      loginUserRole === AgencyRoleType.USER ||
      loginUserRole === AgencyRoleType.CAREGIVER
    ) {
      if (
        Role === AgencyRoleType.ADMIN ||
        Role === AgencyRoleType.OWNER ||
        Role === AgencyRoleType.SUPPORT ||
        Role === AgencyRoleType.SPECIALTYSUPPORT
      ) {
        return true;
      } else if (
        Role === AgencyRoleType.USER ||
        Role === AgencyRoleType.CAREGIVER
      ) {
        // login user role are basic or care giver as per rule both are not chat each other or broadcast
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getUnreadCount(firstRun?) {
    const userId = localStorage.getItem('userEmail') || null;
    if (userId) {
      this.httpService.getUnreadCounts(userId).subscribe({
        complete: () => {
          // console.log('done');
        },
        error: (error) => {
          if (error.status === 401) {
            localStorage.clear();
            this.router.navigate(['/home']);
          }
          const msg = error.error ? error.error.message : error.message;
          // this.openSnackBar(msg, '');
        },
        next: (res) => {
          if (res.length > 0) {
            this.unreadCountList = res.filter((elements) => {
              return elements.email !== null;
            });
            if (this.unreadCountList.length > 0) {
              let totalCount = 0;
              for (let index = 0; index < this.unreadCountList.length; index++) {
                const elementUnread = this.unreadCountList[index];

                //First check if the User has Chat Groups which requires a different process
                let chatGroups: any = localStorage.getItem("chatGroups");
                if (chatGroups) {
                  if (chatGroups.indexOf(elementUnread.email) > -1) {
                    //If Chat group is detected in unread element then find the appropriate Group + User and add
                    let emailIndex = this.connectionList.findIndex((element) => {
                      return element.toUserId === elementUnread.email && element.fromUserId === elementUnread._id
                    });
                    if (emailIndex > -1) {
                      this.connectionList[emailIndex]['unread'] = 1;
                      this.connectionList[emailIndex]['count'] = elementUnread.count;
                      totalCount += elementUnread.count;
                    } else
                      this.getConnections(this.userEmail);
                  } else {
                    //If Chat group is NOT detected in unread element then find the User + User and add
                    let emailIndex = this.connectionList.findIndex((element) => {
                      return element.fromUserId === elementUnread.email && element.toUserId === this.userEmail
                    });

                    if (emailIndex > -1) {
                      this.connectionList[emailIndex]['unread'] = 1;
                      this.connectionList[emailIndex]['count'] = elementUnread.count;
                      totalCount += elementUnread.count;
                    } else
                      this.getConnections(this.userEmail);
                  }
                } else {
                  //Non Group Users find the User + User and add
                  let emailIndex = this.connectionList.findIndex((element) => this.getUserEmail(element) === elementUnread.email);
                  if (emailIndex > -1) {
                    this.connectionList[emailIndex]['unread'] = 1;
                    this.connectionList[emailIndex]['count'] = elementUnread.count;
                    totalCount += elementUnread.count;
                  } else
                    this.getConnections(this.userEmail);
                }
              }
              if (firstRun) 
                this.unreadStart = totalCount;
              
              if (totalCount > this.unreadStart)
                this.getConnections(this.userEmail)
            }
          } else {
            this.unreadCountList = [];
          }
        },
      });
    }
  }

  truncateString(data: any, maxLength: number) {
    if (data.messageType === "MEDIA") {
      return "Attachment: " + data.media;
    } else {
      let string = data.message;
      if (string) {
        if (string.length > maxLength) {
          return string.substring(0, maxLength) + '...';
        } else {
          return string;
        }
      } else {
        return '';
      }
    }
  }

  clearSearch() {
    this.searchValue = "";
    this.getConnections(this.userEmail);
  }

  returnFromTo(data) {
    if (data.toUserId === "SembraCareSuccess")
      return true
    else
      return false
  }

  groupName(data) {
    let chatGroups: any = localStorage.getItem("chatGroups")
    let groupFound = "";
    if (chatGroups) {
      if (chatGroups) {
        let groupList = chatGroups.split(',');
        groupList.map(group => {
          if (group.indexOf(data.toUserId) > -1 && group.indexOf(data.fromUserId) > -1)
            groupFound = "";
          else if (group.indexOf(data.toUserId) > -1 || group.indexOf(data.fromUserId) > -1) {
            if (group.indexOf(data.fromUserId) > -1)
              groupFound = data.fromUserName + " + "
            else
              groupFound = data.toUserName + " + "
            // groupFound = group + " + ";
          }
        })
      }
    }
    return groupFound
  }

  isMessageToSpecialGroup(data) {
    let chatGroups: any = localStorage.getItem("chatGroups");
    if (chatGroups) {
      if (data.toUserId === data.fromUserId)
        return false;
      if (chatGroups.indexOf(data.toUserId) > -1 || chatGroups.indexOf(data.fromUserId) > -1)
        return true;
    }

    return false;
  }
}
